<ng-container *transloco="let t; read: 'saleBanner.summerSale'">
  @switch (bannerStyle) {
    @case ('Full') {
      <div class="bg-blue-10 overflow-hidden rounded-md relative flex flex-col md:flex-row items-center">
        <div class="flex flex-row items-center">
          <img
            class="h-[180px] hidden lg:inline"
            alt=""
            [src]="'assets/images/promotion-banner/summer-sale-2023/left-splash.png' | staticAsset"
          />
          <img class="h-[157px] mt-2 mx-8" alt="" [src]="'assets/images/promotion-banner/summer-sale-2023/summer-blue.png' | staticAsset" />
        </div>
        <div class="text-center md:text-left">
          <strong class="text-blue-50 text-heading-2">Get 5x more Google reviews with 30% off Pro! </strong>
          <p class="text-highlight-purple uppercase text-[1.5rem] md:text-[3rem] font-bold">Save $118</p>
        </div>
        <div class="md:absolute bottom-4 right-4 flex flex-col justify-center py-2 gap-2 md:gap-2 md:py-0">
          <a routerLink="/billing/plans" [queryParams]="{ tier: 'Professional' }" mat-flat-button class="!bg-highlight-purple !text-white">
            {{ t('main.cta') }}
          </a>
          <p class="uppercase text-center text-blue-50 font-bold">Expires June 30</p>
        </div>
      </div>
    }
    @case ('NoCta') {
      <div class="bg-blue-10 overflow-hidden rounded-md relative flex flex-col md:flex-row items-center justify-between">
        <img class="h-[117px] mt-2 mx-8" alt="" [src]="'assets/images/promotion-banner/summer-sale-2023/summer-purple.png' | staticAsset" />
        <div class="text-center px-6 md:px-0">
          <strong class="text-blue-50 text-heading-3 md:text-heading-1">Get all the benefits of Pro at 30% off!</strong>
          <p class="text-highlight-purple uppercase md:text-[1.5rem] font-bold">Don&rsquo;t miss out</p>
        </div>
        <img
          class="h-[128px] hidden lg:inline"
          alt=""
          [src]="'assets/images/promotion-banner/summer-sale-2023/right-splash.png' | staticAsset"
        />
      </div>
    }
    @case ('Small') {
      <div class="bg-blue-10 overflow-hidden rounded-md flex flex-col items-center">
        <p class="text-blue-90 font-bold text-center py-2">
          Almost there! You&rsquo;re *this* close to getting <span class="text-purple-50">30% off</span> RateMyAgent Pro
        </p>
      </div>
    }
  }
</ng-container>
